import { render, staticRenderFns } from "./launchOrModify.vue?vue&type=template&id=3bcef292&scoped=true"
import script from "./launchOrModify.vue?vue&type=script&lang=js"
export * from "./launchOrModify.vue?vue&type=script&lang=js"
import style0 from "./launchOrModify.vue?vue&type=style&index=0&id=3bcef292&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bcef292",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3bcef292')) {
      api.createRecord('3bcef292', component.options)
    } else {
      api.reload('3bcef292', component.options)
    }
    module.hot.accept("./launchOrModify.vue?vue&type=template&id=3bcef292&scoped=true", function () {
      api.rerender('3bcef292', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/product/product-details/firmware/firmwareDetails/launchOrModify.vue"
export default component.exports